import * as React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import PerfectScrollbar from "react-perfect-scrollbar";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReadMoreAndLess from "react-read-more-less";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Chip,
  Checkbox,
  IconButton,
} from "@mui/material";
import InfoTwoToneIcon from "@mui/icons-material/InfoTwoTone";
import PermDeviceInformationTwoToneIcon from "@mui/icons-material/PermDeviceInformationTwoTone";
import Cisinformation from "../Cisinformation/Cisinformation";
import ActualValue from "../Cisinformation/MultiActualValue";

function EnhancedTableHead() {
  return (
    <>
      <TableHead className="bg-lightBlue-200">
        <TableRow className="align-items-center table-flush css-serial">
          <TableCell>Cis_no</TableCell>
          <TableCell>CIS_Topic</TableCell>
          <TableCell>Level</TableCell>
          {window.localStorage.getItem("rollback_run_access") ===
          "You do not have permission to perform this action." ? (
            ""
          ) : (
            <TableCell>Status</TableCell>
          )}
          <TableCell>Result</TableCell>
          <TableCell>Info</TableCell>
        </TableRow>
      </TableHead>
    </>
  );
}

export default function PassedTable(props) {
  const { CisResults, overallAudit, failedAudit, passedAudit } = props;

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const [dropdown, setdropdown] = React.useState([]);

  const checkmoreinfo = (cis_no) => (e) => {
    e.preventDefault();
    var value;
    if (dropdown[cis_no]) {
      value = false;
    } else {
      value = true;
    }
    setdropdown((prevState) => ({ ...prevState, [cis_no]: value }));
  };

  const [newresult, setNewresult] = React.useState([]);
  const [selected, setSelected] = React.useState([]);

  React.useEffect(() => {
    setNewresult({ CisResults });
  }, [CisResults]);
  const [expandedheader, setExpandedheader] = React.useState({});

  const handleChangedropdown = (panel) => (event, isExpanded) => {
    setExpandedheader(isExpanded ? panel : false);
  };
  const isSelected = (cis_no) => selected.indexOf(cis_no) !== -1;

  return (
    <>
      <ActualValue component="remedy" open={open} setOpen={setOpen} />
      <Card sx={{ color: "#ffff", backgroundColor: "#172b4d" }}>
        <CardHeader title="Failed" />
        <CardContent>
          {newresult.CisResults ? (
            <React.Fragment>
              {CisResults.map((val, index) => {
                const isItemSelected1 = isSelected(val.header_id);
                const labelId = `select all desserts-${index}`;
                if (val.failedCount > 0) {
                  return (
                    <div>
                      <Accordion
                        defaultExpanded={expandedheader ? true : false}
                        onChange={handleChangedropdown(val.header_id)}
                        style={{ cursor: "pointer" }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls="panel1bh-content"
                          id="panel1bh-header"
                        >
                          <Typography sx={{ width: "33%", flexShrink: 0 }}>
                            <strong>{val.header_id}</strong> - {val.header_name}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Card>
                            <Paper sx={{ width: "100%" }}>
                              <TableContainer
                                sx={{ maxHeight: 1100 }}
                                component={Paper}
                                style={{ borderColor: "#333" }}
                              >
                                <Table
                                  aria-labelledby="tableTitle"
                                  aria-label="enhanced table"
                                >
                                  <EnhancedTableHead />
                                  <TableBody>
                                    {val.result.map((row, sindex) => {
                                      const isItemSelected = isSelected(
                                        row.cis_no
                                      );
                                      const labelId = `enhanced-table-checkbox-${sindex}`;
                                      if (row.status === "FAILED") {
                                        return (
                                          <React.Fragment>
                                            <TableRow>
                                              <TableCell
                                                align="center"
                                                component="th"
                                                id={labelId}
                                                scope="row"
                                                padding="none"
                                                width="5%"
                                              >
                                                {row.cis_no}
                                              </TableCell>
                                              <TableCell
                                                style={{
                                                  textAlign: "left",
                                                  whiteSpace: "normal",
                                                  wordWrap: "break-word",
                                                }}
                                              >
                                                <ReadMoreAndLess
                                                  className="read-more-content"
                                                  charLimit={100}
                                                  readMoreText="Read more"
                                                  readLessText="Read less"
                                                >
                                                  {row.cis_topic_name}
                                                </ReadMoreAndLess>
                                              </TableCell>
                                              <TableCell
                                                width="10%"
                                                style={{ textAlign: "left" }}
                                              >
                                                {row.level}
                                              </TableCell>
                                              <TableCell
                                                width="10%"
                                                style={{
                                                  textAlignLast: "left",
                                                }}
                                              >
                                                <button
                                                  className="bg-emerald-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                                  type="button"
                                                  disabled
                                                >
                                                  Failed
                                                </button>
                                              </TableCell>
                                              <TableCell
                                                width="5%"
                                                style={{
                                                  textAlignLast: "center",
                                                }}
                                              >
                                                <IconButton
                                                  color="primary"
                                                  size="sm"
                                                  title="Info"
                                                  // id={row.cis_no}
                                                  // aria-controls={
                                                  //   "multiCollapse" + row.cis_no
                                                  // }
                                                  style={{
                                                    padding: "0px",
                                                    color: "lightgreen",
                                                  }}
                                                  onClick={() => {
                                                    window.sessionStorage.setItem(
                                                      "passed_before_fact",
                                                      row.before_actual_value
                                                    );
                                                    window.sessionStorage.setItem(
                                                      "passed_after_fact",
                                                      row.after_actual_value
                                                    );
                                                    handleClickOpen();
                                                  }}
                                                >
                                                  <PermDeviceInformationTwoToneIcon
                                                    fontSize="small"
                                                    color="primary"
                                                  />
                                                </IconButton>
                                              </TableCell>
                                              <TableCell
                                                width="5%"
                                                align="center"
                                              >
                                                <IconButton
                                                  color="primary"
                                                  size="sm"
                                                  title="Info"
                                                  style={{
                                                    padding: "0px",
                                                    color: "lightgreen",
                                                  }}
                                                  onClick={checkmoreinfo(
                                                    row.cis_no
                                                  )}
                                                >
                                                  <InfoTwoToneIcon
                                                    fontSize="small"
                                                    color="lightgreen"
                                                  />
                                                </IconButton>
                                              </TableCell>
                                            </TableRow>
                                            {dropdown[row.cis_no] ? (
                                              <TableRow
                                                id={
                                                  "multiCollapse" + row.cis_no
                                                }
                                              >
                                                <Cisinformation
                                                  OS={window.sessionStorage.getItem(
                                                    "OS"
                                                  )}
                                                  FactName={row.fact_name}
                                                />
                                              </TableRow>
                                            ) : (
                                              ""
                                            )}
                                          </React.Fragment>
                                        );
                                      }
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Paper>
                          </Card>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  );
                }
              })}
              <CardContent style={{ textAlign: "center" }}>
                <span>
                  {" "}
                  *Some Remedy needs system reboot, so you may see them in
                  Failed Status. To get the latest report, please reboot the
                  machine, run the fresh audit to get the latest report{" "}
                </span>
                <br />
              </CardContent>
            </React.Fragment>
          ) : (
            <CardContent style={{ textAlign: "center" }}>
              <span>Loading ...</span>
            </CardContent>
          )}
          <br />
          <br />
        </CardContent>
      </Card>
    </>
  );
}